function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;}\n\t.st3{fill:#2BFF9C;}\n");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  className: "st0"
}, /*#__PURE__*/React.createElement("rect", {
  x: -9.61,
  y: -8.11,
  className: "st1",
  width: 45.8,
  height: 36.5
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Large-DesktopFormValid"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle",
  className: "st2",
  d: "M-3-5h22v22H-3V-5z"
}), /*#__PURE__*/React.createElement("g", {
  id: "check-light",
  transform: "translate(3 5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "st3",
  d: "M11.85-4.87L1.73,5.25l-3.58-3.58c-0.17-0.17-0.44-0.17-0.61,0l-0.41,0.41 c-0.17,0.17-0.17,0.44,0,0.61l4.29,4.29c0.17,0.17,0.44,0.17,0.61,0L12.87-3.85c0.17-0.17,0.17-0.44,0-0.61l-0.41-0.41 C12.29-5.04,12.02-5.04,11.85-4.87z"
})))));
var SvgTick = function SvgTick(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 12.11",
    style: {
      enableBackground: "new 0 0 16 12.11"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick.b7fc3c99.svg";
export { ForwardRef as ReactComponent };